<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00045.installation.fuseauhoraire' | translate"
      [description]="
        'P00045.installation.fuseauhoraire.description' | translate
      "
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00045.installation.fuseauhoraire.title' | translate"
      [titleListe]="'P00045.installation.fuseauhoraire.paysregion' | translate"
      [value]="actionStack!.getValue('cnITimezone')"
      [liste]="P00045TimeZoneTypeEnum"
      [description]="'P00045.installation.fuseauhoraire.helper' | translate"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Connect_Timezone,
          'cnITimezone',
          $event,
          null
        )
      "
    >
    </app-label-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
